import {
  MeterReadingsFilters,
  UtilityConfigFilters,
} from "@features/cx/shared/types/consumerRequest";
import { ActionType, EntityType, ModuleType } from "../../queryKeyFactory";

// ================================
// DISCONNECTION KEY FACTORY
// ================================
export const disconnectKeyFactory = {
  // Consumer operations
  consumerSearch: (
    filters?: any
  ): [ModuleType, EntityType, ActionType, any?] => [
    "cx",
    "disconnectionRequests",
    "consumerSearch",
    filters,
  ],
  exportList: (filters?: any): [ModuleType, EntityType, ActionType, any?] => [
    "cx",
    "disconnectionRequests",
    "disconnectionRequestsExport",
    filters,
  ],
  meterHistory: (consumerId: number): [ModuleType, EntityType, ActionType, number] => [
    "cx",
    "disconnectionRequests",
    "meterHistory",
    consumerId,
  ],
  consumerMetaData: (
    params?: any
  ): [ModuleType, EntityType, ActionType, any?] => [
    "cx",
    "disconnectionRequests",
    "consumerMetaData",
    params,
  ],
  consumerBill: (filters?: any): [ModuleType, EntityType, ActionType, any?] => [
    "cx",
    "disconnectionRequests",
    "consumerBill",
    filters,
  ],

  // Disconnection requests
  list: (filters?: any): [ModuleType, EntityType, ActionType, any?] => [
    "cx",
    "disconnectionRequests",
    "list",
    filters,
  ],
  details: (
    requestId: string
  ): [ModuleType, EntityType, ActionType, string] => [
    "cx",
    "disconnectionRequests",
    "details",
    requestId,
  ],
  create: (): [ModuleType, EntityType, ActionType] => [
    "cx",
    "disconnectionRequests",
    "create",
  ],
  update: (requestId: string): [ModuleType, EntityType, ActionType, string] => [
    "cx",
    "disconnectionRequests",
    "update",
    requestId,
  ],
  delete: (requestId: string): [ModuleType, EntityType, ActionType, string] => [
    "cx",
    "disconnectionRequests",
    "delete",
    requestId,
  ],

  // Summary and statistics
  summary: (params?: any): [ModuleType, EntityType, ActionType, any?] => [
    "cx",
    "disconnectionRequests",
    "summary",
    params,
  ],

  // Activity logs
  activityLogs: (filters?: any): [ModuleType, EntityType, ActionType, any?] => [
    "cx",
    "disconnectionRequests",
    "getActivityLogs",
    filters,
  ],

  // Bill generation operations
  billGeneration: (): [ModuleType, EntityType, ActionType] => [
    "cx",
    "disconnectionRequests",
    "billGeneration",
  ],
  billUpdate: (
    billId: string
  ): [ModuleType, EntityType, ActionType, string] => [
    "cx",
    "disconnectionRequests",
    "billUpdate",
    billId,
  ],
  billApprove: (
    billId: string
  ): [ModuleType, EntityType, ActionType, string] => [
    "cx",
    "disconnectionRequests",
    "billApprove",
    billId,
  ],

  // Consumer support operations
  consumerDisconnect: (
    consumerId: string
  ): [ModuleType, EntityType, ActionType, string] => [
    "cx",
    "disconnectionRequests",
    "consumerDisconnect",
    consumerId,
  ],

  // Utility request configuration
  utilityConfig: (
    filters: UtilityConfigFilters
  ): [ModuleType, EntityType, ActionType, UtilityConfigFilters] => [
    "cx",
    "disconnectionRequests",
    "utilityConfig",
    filters,
  ],

  // Status operations
  approve: (
    requestId: string
  ): [ModuleType, EntityType, ActionType, string] => [
    "cx",
    "disconnectionRequests",
    "approve",
    requestId,
  ],
  reject: (requestId: string): [ModuleType, EntityType, ActionType, string] => [
    "cx",
    "disconnectionRequests",
    "reject",
    requestId,
  ],
  acknowledge: (
    requestId: string
  ): [ModuleType, EntityType, ActionType, string] => [
    "cx",
    "disconnectionRequests",
    "acknowledge",
    requestId,
  ],
  hold: (requestId: string): [ModuleType, EntityType, ActionType, string] => [
    "cx",
    "disconnectionRequests",
    "hold",
    requestId,
  ],
  resolve: (
    requestId: string
  ): [ModuleType, EntityType, ActionType, string] => [
    "cx",
    "disconnectionRequests",
    "resolve",
    requestId,
  ],

  // Workflow operations
  workflow: (
    requestId: string
  ): [ModuleType, EntityType, ActionType, string] => [
    "cx",
    "disconnectionRequests",
    "workflow",
    requestId,
  ],
  timeSlotChoices: (): [ModuleType, EntityType, ActionType] => [
    "cx",
    "disconnectionRequests",
    "timeSlotChoices",
  ],
  billTemplates: (): [ModuleType, EntityType, ActionType] => [
    "cx",
    "disconnectionRequests",
    "billTemplates",
  ],
  category: (): [ModuleType, EntityType, ActionType] => [
    "cx",
    "disconnectionRequests",
    "category",
  ],
  subCategory: (): [ModuleType, EntityType, ActionType] => [
    "cx",
    "disconnectionRequests",
    "subCategory",
  ],
  status: (
    remoteUtilityId: number,
    tab: number
  ): [ModuleType, EntityType, ActionType, number, number] => [
    "cx",
    "disconnectionRequests",
    "status",
    remoteUtilityId,
    tab,
  ],
  meterReadings: (
    filters: MeterReadingsFilters
  ): [ModuleType, EntityType, ActionType, MeterReadingsFilters] => [
    "cx",
    "disconnectionRequests",
    "meterReadings",
    filters,
  ],
  workOrderDetails: (
    search: string
  ): [ModuleType, EntityType, ActionType, string] => [
    "cx",
    "disconnectionRequests",
    "work-order-details",
    search,
  ],

  meterInfo: (
    search: string,
    utilityService: string
  ): [ModuleType, EntityType, ActionType, string, string] => [
    "cx",
    "disconnectionRequests",
    "meterReadings",
    search,
    utilityService,
  ],
};
